// SinkingFundDetailsStyle.ts

export const sinkingFundMerges = [
  { row: 0, col: 1, rowspan: 1, colspan: 2 }, // Merge B1 and C1
  { row: 5, col: 1, rowspan: 1, colspan: 2 }, // Merge B6 and C6
  { row: 3, col: 7, rowspan: 3, colspan: 1 }, // H4:H6
  { row: 3, col: 8, rowspan: 3, colspan: 1 }, // I4:I6
  { row: 3, col: 9, rowspan: 3, colspan: 1 }, // J4:J6
  { row: 3, col: 10, rowspan: 3, colspan: 1 }, // K4:K6
  { row: 2, col: 27, rowspan: 4, colspan: 1 }, // AB3:AB6
];

export const sinkingFundColWidths = (index: number): number => {
  if (index === 0) return 20;
  if (index === 1) return 150;
  if (index === 2) return 150;
  if (index === 3) return 250;
  if (index === 4) return 50;
  if (index === 7 || index === 8 || index === 9 || index === 10) return 60;
  if (index >= 11 && index <= 26) return 60;
  return 100;
};

export function getSinkingFundCellClassNames(row: number, col: number): string[] {
  const classNames: string[] = [];
  // Left align B1
  if (row === 0 && col === 1) {
    classNames.push('htLeft');
  } else if (row >= 0 && row <= 3) {
    classNames.push('htCenter');
  }
  // Center B6:C6 merged cell
  if (row === 5 && col === 1) {
    classNames.push('htCenter');
  }
  // Center all merged cells (horizontal and vertical)
  if (
    (row === 0 && col === 1) || // B1
    (row === 5 && col === 1) || // B6
    (row === 3 && col === 7) || // H4
    (row === 3 && col === 8) || // I4
    (row === 3 && col === 9) || // J4
    (row === 3 && col === 10) || // K4
    (row === 2 && col === 27)    // AB3
  ) {
    classNames.push('htCenter', 'htMiddle');
  }
  // L5 to AA5 and L6 to AA6: centered (and numeric if already set)
  if ((row === 4 || row === 5) && col >= 11 && col <= 26) {
    classNames.push('htCenter', 'htMiddle');
  }
  // M5:AA5 and M6:AA6 (row 4,5 col 12-26) - numeric, 3 decimals
  if ((row === 4 || row === 5) && col >= 12 && col <= 26) {
    classNames.push('numeric-3dp');
  }
  // Grey background for AC1:AT300 (columns 28–45, rows 0–299)
  if (row >= 0 && row < 300 && col >= 28 && col <= 45) {
    classNames.push('grey-bg');
  }
  // B1
  if (row === 0 && col === 1) classNames.push('bold');
  // B6, D6, F6, G6, H6, I6, J6, K6
  if (row === 5 && [1, 3, 5, 6, 7, 8, 9, 10].includes(col)) classNames.push('bold');
  // L4 - AA4 (col 11 to 26)
  if (row === 3 && col >= 11 && col <= 26) classNames.push('bold');
  // AB4 (col 27)
  if (row === 3 && col === 27) classNames.push('bold');
  // AB3 (row 2, col 27)
  if (row === 2 && col === 27) classNames.push('bold');
  // B4 (row 3, col 1)
  if (row === 3 && col === 1) classNames.push('bold');
  // H5, I5, J5, K5 (row 4, cols 7, 8, 9, 10)
  if (row === 4 && [7, 8, 9, 10].includes(col)) classNames.push('bold');
  // H4, H5, H6 and the next 4 columns to the right (cols 7-11) in rows 3, 4, 5
  if ([3, 4, 5].includes(row) && col >= 7 && col <= 11) classNames.push('bold');
  // Columns H, I, J (cols 7, 8, 9): yellow background on Sinking Fund Details
  if (col >= 7 && col <= 9) classNames.push('yellow-bg');
  // Column A (col 0): dark grey background on Sinking Fund Details
  if (col === 0) classNames.push('dark-grey-bg');
  // Column E (col === 4): red background, white text
  if (col === 4) classNames.push('red-bg-white-text');
  return classNames;
} 